/** Task description pipeline (client side) — normalization + the expandable
 *  details state for task rows. Pure, unit-tested. */

export const DESCRIPTION_MAX = 500;

/** Trim + cap; empty text means "no description" (null). */
export function normalizeDescription(raw: string | null | undefined): string | null {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return null;
  return trimmed.slice(0, DESCRIPTION_MAX);
}

/** Toggle one row id inside the expanded-details set (pure). */
export function toggleExpanded(ids: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(ids);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

/** Rows with a description show the details affordance; others never do. */
export function hasDetails(task: { description?: string | null }): boolean {
  return normalizeDescription(task.description) !== null;
}
